<template>
  <div id="app" class="h-screen flex justify-center px-10">
      <SellDomain></SellDomain>
  </div>
</template>

<script>
import SellDomain from './components/SellDomain.vue'

export default {
  name: 'app',
  components: {
    SellDomain
  }
}
</script>
